(() => {
  // ========== カートバッジ表示制御 ==========
  document.addEventListener('cart:updated', (event) => {
    document.querySelectorAll('.header__cart-count').forEach((el) => {
      el.hidden = event.detail.cart['item_count'] === 0;
    });
  });

  // ========== モバイルメニュー 開閉アニメーション無効化 ==========
  document.addEventListener('mobile-nav:open', (event) => {
    event.target
      .querySelectorAll('.mobile-nav__item[data-level="1"], .drawer__footer')
      .forEach((item) => {
        item.getAnimations().forEach((animation) => animation.finish());
        item.style.opacity = '1';
        item.style.transform = 'none';
      });
  });

  // ========== メガメニュー: featured見出し/リンクの登場アニメーション ==========
  // テーマは .mega-menu__column / .mega-menu__image-push のみ登場アニメを付けるため、対象外の2要素を同じ動きで補完
  document.addEventListener('desktop-nav:dropdown:open', () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const megaMenu = document.querySelector('.mega-menu:not([hidden])');
    if (!megaMenu) return;

    const heading = megaMenu.querySelector('.c_mega-menu__featured-heading');
    const link = megaMenu.querySelector('.c_mega-menu__featured-link');
    const imageCount = megaMenu.querySelectorAll('.mega-menu__image-push').length;

    const reveal = (el, delay) => {
      if (!el) return;
      el.getAnimations().forEach((animation) => animation.cancel());
      el.animate(
        { opacity: [0, 1], transform: ['translateY(20px)', 'translateY(0)'] },
        { duration: 250, delay: delay, easing: 'cubic-bezier(0.65, 0, 0.35, 1)', fill: 'backwards' }
      );
    };

    reveal(heading, 100);
    reveal(link, 100 + 60 * (imageCount + 1)); // 画像群の後に出す
  });

  // ========== 透明ヘッダー ホバー連動 ==========
  const announcementBar = document.querySelector('.shopify-section--announcement-bar');
  const sectionHeader = document.querySelector('.shopify-section--header');

  if (!announcementBar || !sectionHeader) return;

  const storeHeader = sectionHeader.querySelector('.has-transparent');
  if (!storeHeader) return;

  // スマホ（タッチ端末）ではテーマ純正のホバー連動を無効化し、タップでロゴ等が切り替わらないようにする
  if (!window.matchMedia('(any-hover: hover)').matches) {
    customElements.whenDefined('store-header').then(() => {
      storeHeader.delegate?.off('mouseenter');
      storeHeader.delegate?.off('mouseleave');
    });
  }

  const activate = () => {
    announcementBar.classList.add('is-active');
    sectionHeader.classList.add('is-active');
    storeHeader.lockTransparency = true; // テーマと同じくロゴ等を非透過表示にする
  };
  const deactivate = () => {
    announcementBar.classList.remove('is-active');
    sectionHeader.classList.remove('is-active');
    storeHeader.lockTransparency = false;
  };

  // ホバー可能な端末（PC）のみ連動。スマホのタップでは発火させない
  if (window.matchMedia('(any-hover: hover)').matches) {
    announcementBar.addEventListener('mouseenter', activate);
    announcementBar.addEventListener('mouseleave', deactivate);
    sectionHeader.addEventListener('mouseenter', activate);
    sectionHeader.addEventListener('mouseleave', deactivate);
  }
})();
